// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreviewEditor_wrapper__10nH7","addIcon":"PreviewEditor_addIcon__2gF5x","cropper":"PreviewEditor_cropper__osrMc","image":"PreviewEditor_image__1z0a4"};